import { useEffect } from "react";
import { CLEARBOOK_BOOKING_URL } from "@/lib/clearbook";

/**
 * Any traffic that still hits /book (bookmarks, old links, cached routes)
 * is redirected to Clearbook's external booking page.
 */
export const BookRedirect = () => {
  useEffect(() => {
    window.location.replace(CLEARBOOK_BOOKING_URL);
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <p className="text-white/70 font-light text-sm tracking-[0.14em] uppercase">
        Sender dig videre til booking …
      </p>
    </div>
  );
};
